export const FORM_COMPONENT_WIDTH = 290;
export const SECTION_BOX_WIDTH = 650;
export const TOP_NAV_HEIGHT = 48;
